import { render, staticRenderFns } from "./ToggleModal.vue?vue&type=template&id=5fc08ff5&"
import script from "./ToggleModal.vue?vue&type=script&lang=js&"
export * from "./ToggleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc08ff5')) {
      api.createRecord('5fc08ff5', component.options)
    } else {
      api.reload('5fc08ff5', component.options)
    }
    module.hot.accept("./ToggleModal.vue?vue&type=template&id=5fc08ff5&", function () {
      api.rerender('5fc08ff5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/services/ToggleModal.vue"
export default component.exports